import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AppLoader from "./AppLoader";

export default function ProtectedRoute({ children }) {
  const { status, error, retry } = useAuth();

  if (status === "loading") return <AppLoader />;
  if (status === "error") return <AppLoader error={error} onRetry={retry} />;
  if (status !== "ready") return <Navigate to="/login" replace />;
  return children;
}
